import React, { useEffect } from 'react'
import { useSessionData } from '../../components/sessionContext'

// react router
import { withRouter } from 'react-router-dom'

// styles
import './index.css'

const Logout = props => {
  // session
  const session = useSessionData()
  session.logout()

  useEffect(() => {
    return props.history.push('/login')
  }, [])

  return (
    <div className='Logout'>Logging you out</div>
  )
}

export default withRouter(Logout)
